import styled from '@emotion/styled';

import * as c from '@identity/constants';
import { remCalc } from '@lib/styleMethods';

export const ServicesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-items: center;
`;

const LABEL_COLORS: Record<ResourceCardT, string> = {
  0: '#fef8f7',
  1: '#fbeae6',
  2: '#f8dcd5',
};

export const ServiceContainer = styled.div`
  background: red;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => LABEL_COLORS[props.color]};
  padding: 30px 30px;
  min-width: 200px;

  img {
    width: 100px;
  }

  ${c.TABLET} {
    min-width: 300px;
  }
`;

export const IconWrapper = styled.figure`
  padding-bottom: 80px;

  svg {
    height: 300px;
  }
`;
